import { ReactComponent as EditIcon } from "../../../assets/icons/new-edit-icon.svg";
import { ReactComponent as DragIcon } from "../../../assets/icons/drag-icon.svg";
import { UBButton, UBChip } from "../../../Libraries";
import LineText from "../../../Libraries/LineText";
import { analytics, triggerLogEvent } from "../../../config/firebase";

const SelectedAttrComponent = ({
  keyId,
  attributes = [],
  handleEdit,
  editDisabled = false,
  ...props
}) => {
  return (
    <div
      className='p-3 marginTop20'
      {...props}
      style={{ background: "#F7FBFA", borderRadius: "8px" }}
    >
      <div className='d-flex align-items-center justify-content-between'>
        <div className='d-flex align-items-center align-self-start'>
          <DragIcon role='button' />
          <LineText>{keyId}</LineText>
        </div>
        {!editDisabled ? (
          <UBButton
            id="selected_attr_edit_btn"
            title='Edit'
            iconComponent={<EditIcon />}
            iconPlacement='right'
            titleStyle={{ color: "var(--darkGray)", fontSize: "0.75rem" }}
            className='ub_ButtonMain editAttrBtn'
            onClick={() => { triggerLogEvent(analytics, "sb_variant_attr_select", { attr_key: keyId }); handleEdit?.(); }}
          />
        ) : (
          <></>
        )}
      </div>
      <div className='d-flex gap-2 flex-wrap align-items-center mx-3 my-2'>
        {attributes.map((attr, ind) => (
          <UBChip
            key={`${attr}-${ind}`}
            title={attr.value}
            className='bg-white'
          />
        ))}
      </div>
    </div>
  );
};

export default SelectedAttrComponent;
